import { FunctionComponent } from 'react'
import { InputWithHyphen } from '@dxp-module/common'
import { MyAccountWidgetProps } from '../../../model/MyAccountWidgetProps'
import inputFieldWithHyphenStyles from './inputFieldWithHyphen.styles'

const InputFieldWithHyphen: FunctionComponent<MyAccountWidgetProps> = props => {
  const styles = inputFieldWithHyphenStyles()

  return <InputWithHyphen {...props} classes={styles} />
}

export default InputFieldWithHyphen
